window.app = window.app || {};

window.app.collection = {
    el: {
        body: document.querySelector('body'),
        box: document.querySelector('.mt-collection__sort-by .mt-select-box'),
        boxTop: document.querySelector('.mt-collection__sort-by .mt-select-box__top'),
        boxClose: document.querySelectorAll('.mt-collection__sort-by .mt-select-box__close, .mt-collection__sort-by .mt-select-box-overlay'),
        boxOptions: document.querySelectorAll('.mt-collection__sort-by .mt-select-box__option'),
        trigger: document.querySelector('.mt-collection__sort-by .mt-select'),
        labels: document.querySelectorAll('.mt-collection__sort-by .mt-select__label')
    },

    init: function () {
        const _this = this;
        if (!_this.el.box) return;

        // Query params
        Shopify.queryParams = {};
        if (location.search.length) {
            const params = location.search.substr(1).split('&');
            for (var i = 0; i < params.length; i++) {
                const keyValue = params[i].split('=');
                if (keyValue.length) {
                    Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
                }
            }
        }

        // Custom select
        const { body, boxTop, box, boxOptions, labels, boxClose } = _this.el;
        const toggleBoxActive = () => {
            box.classList.toggle('active');
            (window.innerWidth < 768) && body.classList.toggle('mt-modal-active', box.classList.contains('active'));
        };

        boxTop?.addEventListener('click', e => {
            if (window.innerWidth >= 768) toggleBoxActive();
        });

        boxOptions?.forEach(option => {
            option.addEventListener('click', e => {
                e.preventDefault();
                Shopify.queryParams.sort_by = option.dataset.option;
                window.top.location.search = new URLSearchParams(Shopify.queryParams).toString();
            });
        });

        labels?.forEach(label => {
            label.addEventListener('click', toggleBoxActive);
        });

        boxClose?.forEach(close => {
            close.addEventListener('click', e => {
                e.preventDefault();
                box.classList.remove('active');
                body.classList.remove('mt-modal-active');
            });
        });
    }
};

window.app.collection.init();